import type { InterestZoneRun, InterestZoneRunParams } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const startInterestZoneRun = async (
  params: InterestZoneRunParams,
): Promise<InterestZoneRun> => {
  const { data } = await gozokiApiWithAuth.post<InterestZoneRun>('/interest-zone-runs', params)
  return data
}

export const deleteInterestZoneRun = async (key: string): Promise<void> => {
  await gozokiApiWithAuth.delete(`/interest-zone-runs/${key}`)
}
